import React from 'react';
import { makeStyles, createStyles } from '@material-ui/core';
import Spinner from '../spinner/Spinner';


const useStyles = makeStyles(createStyles({
  root: {
    height: '475px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  spinner: {
    display: 'flex',
  },
}), { name: 'Loading' });

type Props = {
  loading: boolean;
  loadingText: string;
};

const Loading = ({ loading }: Props) => {
  const classes = useStyles();

  return loading ? (
    <div className={classes.root}>
      <Spinner className={classes.spinner} />
    </div>
  ) : null;
};

export default Loading;
